import type { SelectOption } from '@atlassian/jira-common-components-picker';
import type { SingleVersion } from '../common/types';
import { MAX_RESULTS } from '../rest';
import type { SingleVersionResponse } from '../rest/types';

export const transformVersion = (
	component: SingleVersionResponse | SingleVersion,
): SelectOption => ({
	value: component.id,
	label: component.name,
});

export const transformVersions = (
	data: SingleVersionResponse[],
	ignore: string[],
	excludeArchivedVersions: boolean,
): SelectOption[] =>
	data
		.filter((value) => !ignore.includes(value.id) && (!excludeArchivedVersions || !value.archived))
		.map(transformVersion)
		.slice(0, MAX_RESULTS);
